module.exports = __webpack_public_path__ + "static/media/help.d30dbe2d.png";